import { Collapse, Divider } from 'antd';
import { useState, forwardRef, useImperativeHandle } from 'react';
import { DeleteIcon } from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { JobCancellationStatusEnum, JobItem } from 'domains/workspaceDomain';
import UniversalWorkspaceItem from 'features/Workspace/list/UniversalWorkspaceItem';
import { UnderlineText } from 'components/RevxTypography';
import { getFormatDate, ORDER_DATE_FORMAT } from 'components/RevxDate';
import useJobCardInfo from '../../Workspace/hooks/useJobCardInfo';

const { JOB_CANCELED } = JobCancellationStatusEnum;

const ACTIVE_KEY = ['1'];

type PreConfigJobItemProps = {
  item: JobItem;
  refreshJobList: () => void;
};

export type PreConfigJobItemRef = {
  openCollapse: () => void;
};

const JobArchiveItem = forwardRef<PreConfigJobItemRef, PreConfigJobItemProps>(
  ({ item, refreshJobList }, ref) => {
    const [activeKey, setActiveKey] = useState<string[]>([]);

    useImperativeHandle(ref, () => ({
      openCollapse: () => {
        setActiveKey(ACTIVE_KEY);
      },
    }));

    const { id, name, quantity, skuName, cancellationStatus, updateAt } = item;
    const { shipDate } = useJobCardInfo(item);

    const showCancel = cancellationStatus === JOB_CANCELED;

    const toggleCollapse = () => {
      activeKey.length ? setActiveKey([]) : setActiveKey(ACTIVE_KEY);
    };

    const genHeader = () => {
      const date = () => {
        if (!showCancel) {
          return (
            <div className="date-wrap bold">
              <span>Ship date: </span>
              <span>{shipDate}</span>
            </div>
          );
        }
        return (
          <div className="date-wrap cancel-red bold">
            {`Job Canceled: Notified on ${getFormatDate({
              dateStr: updateAt || '',
              formatStr: ORDER_DATE_FORMAT,
              isLocalTime: true,
            })}`}
          </div>
        );
      };
      return (
        <RevxFlexLayout className="header">
          <div className="header__id">
            <span className="bold">Job ID: </span>
            <span>{id}</span>
          </div>
          <Divider type="vertical" />
          <div className="header__name bold">
            <UnderlineText
              color="green"
              onClick={() => {
                toggleCollapse();
              }}
            >
              {name}
            </UnderlineText>
          </div>
          <Divider type="vertical" />
          <div>
            <span className="bold">{skuName}</span>
          </div>
          <Divider type="vertical" />
          <div className="header__count">
            <span className="bold">QTY: </span>
            <span>{quantity}</span>
          </div>
          <div
            className="header__click-area click"
            onClick={() => {
              toggleCollapse();
            }}
          />
          <div>{date()}</div>
        </RevxFlexLayout>
      );
    };
    const genExtra = () => {
      return (
        <div onClick={() => setActiveKey([])}>
          <DeleteIcon />
        </div>
      );
    };

    return (
      <Collapse collapsible={'disabled'} activeKey={activeKey}>
        <Collapse.Panel
          key={ACTIVE_KEY[0]}
          header={genHeader()}
          showArrow={false}
          extra={genExtra()}
        >
          <UniversalWorkspaceItem data={item} />
        </Collapse.Panel>
      </Collapse>
    );
  }
);

export default JobArchiveItem;
